import config from '../config';
import http from '@/utils/http';
import { logger } from '@/utils/screenEventsLogger';

export const apiWeatherCurrentConditions = async (location, language = 'en', type) => {
  try {
    const url = new URL('userapi/app/weather/get-weather', config.apiUrl);

    return await http.post(
      url.toString(),
      {
        location,
        language,
        type,
      },
      { 'axios-retry': { retries: 0 } },
    );
  } catch (error) {
    logger.addLog(`Weather API request failed: ${error?.message}. Type: ${type}`);

    return null;
  }
};
